module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "chapter"
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/image-5.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('h1', [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AYING")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RACE")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page6"
    }
  }), _vm._v("Expressing gratitude for the food on our tables is universal. People in all times and in every place have felt the need to say thanks for what they are about to eat. Whether graces are said over meals eaten with chopsticks or spoons, around a campfire, or over the best holiday dishes, they are part of every culture.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The graces and table blessings in "), _c('i', [_vm._v("Saying Grace")]), _vm._v(" are like stuffing recipes. There are many different kinds, and everyone has a favorite. Some, like celery, onion, and bread crumbs, are simply traditional. Passed from one generation to another and repeated daily or yearly at holidays, they are as familiar at the table as the traditional foods they share. Other blessings in "), _c('i', [_vm._v("Saying Grace")]), _vm._v(" are exotic, like recipes that call for unusual fruits and spices.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The graces found here are drawn from a variety of great religious books and connect us to our ancient pasts. Some are regional. Like a recipe for Louisiana Crayfish Jambalaya stuffing, they evoke a certain time and place. The ceremonial Native American corn-planting chants, for example, take us for a moment to the early American Great Plains, while 17th-century fishermen’s prayers hark back to the rugged coast of Scotland.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Most blessings collected in "), _c('i', [_vm._v("Saying Grace")]), _vm._v(" address some form of the sacred, but also included are those like the “cowboy blessings” and “singing graces” that say thanks in a slightly more irreverent and humorous manner.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("All of the selections are intended to inspire thoughts of gratitude. Many traditions call for spontaneous expressions of "), _c('a', {
    attrs: {
      "id": "page7"
    }
  }), _vm._v("thankfulness spoken by those present around the table. Others simply sit together in a moment of shared, silent thankfulness.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Since many of the world’s greatest writers, poets, humanitarians, and philosophers have composed poems or words of gratitude for their daily bread, "), _c('i', [_vm._v("Saying Grace")]), _vm._v(" includes quotations from St. Francis of Assisi; Zoroaster, the late 7th century Persian philosopher; Josephine Delphine Henderson Heard, the African-American poet; and Dorothy Day, cofounder of the Catholic Worker movement.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A number of the entries are anonymous—blessing and graces that have outlasted our knowledge of their authors. Much research was done in the compiling of this book to trace the origins of these blessings, but in many cases their sources may no longer be available. Some, like the proverbs—sayings that express generally accepted observations on human behavior—could arguably be attributed to many different sources.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("Saying Grace")]), _vm._v(" is an eclectic collection of graces and food blessings from different centuries, cultures, and geographic locations. Intended for holidays and every day, it can be passed around the table or enjoyed silently, opened every night or whenever the spirit moves you.")]), _vm._v(" "), _c('p', {
    staticClass: "white1"
  }), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/image-7.jpg"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c630382","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/004sayinggrace.vue
// module id = 63
// module chunks = 0